// extracted by mini-css-extract-plugin
export default {"logout":"GtsjjNC4mjJBZESaE3Ho","link":"zzwT9Tqnmls7OM29YmCN","notificationButton":"_FixSYn7FMxqV3fq3qGT"};